import * as S from "./styles";
import { LoadingItem } from "@local-logic/core/ui";
import { Score, scoreCategories } from "@local-logic/elements-react";
import React, { useEffect } from "react";
import useFilterSortScores from "~/hooks/useFilterSortScores";
import { useLocalContent } from "~/sdks/LocalContent/context";

interface CategoryScoresProps {
  category: (typeof scoreCategories)[number];
}

const activeScoreByCategory = {
  commute: "transit_friendly",
  amenities: "groceries",
  character: "quiet",
  nature: "parks",
  education: "primary_schools",
  wellness: "wellness",
};

const CategoryScores = ({ category }: CategoryScoresProps) => {
  const { activeScore, setActiveScore, setActiveCategory } = useLocalContent();
  const { cleanScores, data, isLoading, isFetching } = useFilterSortScores(
    category.scores
  );

  useEffect(() => {
    if (cleanScores.length > 0) {
      setActiveScore(cleanScores[0]);
    }
  }, [cleanScores]);

  return (
    <S.CategoryScores>
      {cleanScores.length > 0 &&
        cleanScores.map((score) => {
          const isActive = score === activeScore;
          const color = isActive ? "--ll-color-primary" : "--ll-color-disabled";

          if (isLoading || isFetching) {
            return (
              <S.LoadingItemContainer key={score}>
                <LoadingItem height="44px" width="60px" />
              </S.LoadingItemContainer>
            );
          }

          return (
            <Score.Root key={score} options={{ score, scoresData: data }}>
              <S.ScoreItem
                onClick={() => {
                  setActiveCategory(category.value);
                  setActiveScore(score);
                }}
              >
                <Score.Icon options={{ color, height: 28, width: 28 }} />
                <S.TextContainer>
                  <Score.Title
                    options={{
                      variant: "caption1",
                      color,
                      lineClamp: 1,
                      noMargin: true,
                      weight: "--ll-font-weight-bold",
                    }}
                  />
                </S.TextContainer>
                <S.BadgeContainer>
                  <Score.Badge
                    options={{ variant: "small", isPrimary: isActive }}
                  />
                </S.BadgeContainer>
              </S.ScoreItem>
            </Score.Root>
          );
        })}
    </S.CategoryScores>
  );
};

export default CategoryScores;
